import { Navigate, Outlet } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"

const RoleRouteGuard = ({ allowRoles = [], children }) => {
  const { roleId, isLogin, isChecking } = useAuth()

  // 認証チェック中は何も描画しない
  if (isChecking) return null

  // ログインしていない場合はログイン画面へ遷移
  if (!isLogin) {
    return <Navigate to="/" replace />
  }

  // 権限IDをチェック
  if (allowRoles.length > 0) {
    const userRole = Number(roleId)

    if (!allowRoles.includes(userRole)) {
      return <Navigate to="/" replace />
    }
  }

  return children ? children : <Outlet />
}

export default RoleRouteGuard